import styled from "styled-components";
import Backdrop from "../Backdrop";
import ModalWrapper from "../ModalWrapper";
import Spacer from "../Spacer";
import Button from "../Button";
import ConnectChannelIllus from "assets/images/connect-channel-eng.png";
import { useState } from "react";

const Wrapper = styled(Backdrop)`
  .modal {
    background-color: #fff;
    width: 560px;
    padding: 24px;
    border-radius: 16px;
  }

  img {
    width: 100%;
    height: auto;
  }

  .content {
    text-align: center;
    font-size: 16px;
    font-weight: 450;

    header {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 6px;
    }

    .text {
      color: var(--body_text);
    }
  }
  .btn-flex {
    gap: 12px;

    button {
      font-size: 14px;
    }
  }

  .stepper-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin: 12px 0;

    .stepper {
      width: 8px;
      height: 8px;
      background-color: var(--grey_9);
      border-radius: 50%;
    }

    .active {
      background-color: var(--secondary);
    }
  }

  @media screen and (max-width: 768px) {
    .modal {
      width: calc(100% - 24px);
    }

    .content {
      font-size: 14px;

      header {
        font-size: 16px;
      }
    }
  }
`;

const Steps = ({ currStep }) => {
  switch (currStep) {
    case 1:
      return (
        <>
          <div className="content">
            <header>Exciting news! Your dashboard just got an upgrade!</header>
            <p className="text">
              Time to streamline your workflow! New features are here to make
              your social media management smoother and smarter.
            </p>
          </div>
          <Spacer y={2.4} />
          <img src={ConnectChannelIllus} alt="illustration" />
        </>
      );
    case 2:
      return (
        <>
          <div className="content">
            <header>Introducing Paddy AI Assistant</header>
            <p className="text">
              Unlock creative writing assistance, brainstorm content ideas, and
              optimize your posts with our new AI assistant.
            </p>
          </div>
          <Spacer y={2.4} />
          <img src={ConnectChannelIllus} alt="illustration" />
        </>
      );
    case 3:
      return (
        <>
          <div className="content">
            <header>Schedule first comments on Instagram!</header>
            <p className="text">
              Grab attention from the start with scheduled first comments for
              your Instagram posts - perfect for hashtags, links, and
              announcements.
            </p>
          </div>
          <Spacer y={2.4} />
          <img src={ConnectChannelIllus} alt="illustration" />
        </>
      );
    default:
      return;
  }
};

const NewFeatureEngagement = () => {
  const [displayModal, setDisplayModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);

  const handleBtnClick = () => {
    if (currentStep < 3) {
      setCurrentStep((prev) => prev + 1);
    } else {
      setDisplayModal(false);
    }
  };

  return (
    <Wrapper className={`flexRow justifyEnd ${displayModal && "show"}`}>
      <ModalWrapper>
        <div className="modal">
          <Steps currStep={currentStep} />

          <div className="stepper-row">
            <div className={`stepper ${currentStep === 1 && "active"}`}></div>
            <div className={`stepper ${currentStep === 2 && "active"}`}></div>
            <div className={`stepper ${currentStep === 3 && "active"}`}></div>
          </div>

          <div className="flexRow alignCenter justifySpaceBetween btn-flex">
            <Button
              className="borderedGrey"
              text="Cancel"
              width="120px"
              onClick={() => setDisplayModal(false)}
            />
            <Button
              onClick={handleBtnClick}
              text={currentStep < 3 ? "Next" : "Done"}
              bg="var(--secondary)"
              width="120px"
            />
          </div>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};

export default NewFeatureEngagement;
